import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
// layouts
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to="/dashboard/home" replace />,
    },
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/home" replace />, index: true },
        { path: 'home', element: <HomePage /> },
        { path: 'essays', element: <EssaysPage /> },
        { path: 'rating', element: <RatingPage /> },
        { path: 'experts', element: <ExpertsPage /> },
        { path: 'topics', element: <TopicsPage /> },
        { path: 'essays/new', element: <NewEssayPage /> },
        { path: 'essays/:id', element: <EssayDetailPage /> },
        { path: 'profile', element: <ProfilePage /> },
        { path: 'transactions', element: <TransactionsPage /> },
        { path: 'expert-application', element: <ExpertApplicationPage /> },
        { path: 'feedback', element: <FeedbackPage /> },
      ],
    },
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },
  ]);
}

// Pages
const HomePage = Loadable(lazy(() => import('../pages/HomePage')));
const EssaysPage = Loadable(lazy(() => import('../pages/EssaysPage')));
const RatingPage = Loadable(lazy(() => import('../pages/RatingPage')));
const ExpertsPage = Loadable(lazy(() => import('../pages/ExpertsPage')));
const TopicsPage = Loadable(lazy(() => import('../pages/TopicsPage')));
const NewEssayPage = Loadable(lazy(() => import('../pages/NewEssayPage')));
const EssayDetailPage = Loadable(lazy(() => import('../pages/EssayDetailPage')));
const ProfilePage = Loadable(lazy(() => import('../pages/ProfilePage')));
const TransactionsPage = Loadable(lazy(() => import('../pages/TransactionsPage')));
const ExpertApplicationPage = Loadable(lazy(() => import('../pages/ExpertApplicationPage')));
const FeedbackPage = Loadable(lazy(() => import('../pages/FeedbackPage')));
const NotFound = Loadable(lazy(() => import('../pages/Page404')));
